import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'PurchaseReturn_UPDATE',
    smsDelete : 'PurchaseReturn_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        return: [],
        return_count:null,
        return_detail: {},

        return_by_grn:[],
     

        submitLoading: false,
        submitError: false,
        submitSuccess: false,
    
        ...store
    },

    mutations : {
        ...mutations,

        SET_PURCHASE_RETURN (state, {data, pg_count}) {
            state.return = data;
            state.return_count = pg_count;
        },
        SET_PURCHASE_RETURN_BY_GRN(state, data) {
            state.return_by_grn = data;
          
        },
    
        SET_PURCHASE_RETURN_DETAIL (state, item) {
            state.return_detail = item;
        },
       
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },
    },

    actions: {
        async addPurchaseReturn ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let response = await axios.post(V1API.create_purchase_return, payload.return, config).then(result=>{
                    let data = result.data
                    return data

                });

                if(payload.from_details) {
                    dispatch("fetchPurchaseReturnBY_GRN", payload.grn_id)
                }

                commit('SUBMIT_SUCCESS', true);
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async fetchPurchaseReturn ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                if (payload.status) params.append('status', payload.status);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.raised_by) params.append('raised_by', payload.raised_by);
                if (payload.req_type) params.append('type_id', payload.req_type);
               
           
                let url = V1API.get_purchase_return_list + '?' + params.toString();
                let result = await axios.get(url, config);

                const {data, pg_count} = result.data

                commit('SET_PURCHASE_RETURN', {data, pg_count});
                return result
               

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async confirmPurchaseReturn({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {

                let response = await axios.get(V1API.confirm_purchase_return + payload.id, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPurchaseReturn', {currentPage:payload.page,perPage:payload.perPage, status:payload.status,raised_by:payload.raised_by,search_term:payload.search_term})
                
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async deletePurchaseReturn ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_purchase_return + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })

            if(payload.from_details) {
                dispatch("fetchPurchaseReturnBY_GRN", payload.grn_id)
            } else {
                dispatch ('fetchPurchaseReturn', {currentPage:payload.page,perPage:payload.perPage, status:payload.status,raised_by:payload.raised_by,search_term:payload.search_term})
            }
            return response
        },

        async fetchPurchaseReturnDetail ({ commit,dispatch }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_purchase_return_detail + payload, config);
                let response = result.data
                commit('SET_PURCHASE_RETURN_DETAIL', response.data);
                

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async fetchPurchaseReturnBY_GRN ({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let params = new URLSearchParams();
                let url = V1API.get_purchase_return_by_grn + payload;
                let result = await axios.get(url, config);
                const results = result.data
                commit('SET_PURCHASE_RETURN_BY_GRN', results.data);
                return result
               
            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        }
    },

    getters: {}
}
